<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  body {
    margin: 0;
    font-family: arial;
    font-weight: 300;
    color: #333;
  }
  video {
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// App.vue?3e6a211f